export default __webpack_public_path__ + "fafaa6dd212c9d0194b334e4abc3e86f.svg";